import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OverLimitItem } from '@core/store/cart/cart-state-models';

@Component({
  selector: 'app-quantity-limit-updated-modal',
  templateUrl: './quantity-limit-updated-modal.component.html',
  styleUrls: ['./quantity-limit-updated-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityLimitUpdatedModalComponent {
  @Input() items: OverLimitItem[] = [];
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
